module.exports = __webpack_public_path__ + "img/timer_play_outlined.94854cc5.svg";